export enum ErrorMessages {
  NoError,
  OneAttemptLeft,
  TwoAttemptsLeft,
  LockedOut,
  PinWiped,
  NoPinSet,
  WrongPassOrUser,
  FingerprintWiped,
  NoFingerprintSet,
  AccountDisabled,
  RefreshFailed,
  UnExpectedError,
  TempUser
}
